import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { Typography } from 'seagull/components/Typography';
import IntroVideoModalContent from '~/components/AgreementStudioPage/AgreementStudioModal/IntroVideo/IntroVideoModal/IntroVideoModalContent';
import { IntroVideoType } from '~/models/intro-video';
import EditableTableCell from '../EditableTableCell/EditableTableCell';
const IntroductoryVideoModalContent = (param)=>{
    let { draft, setDraft } = param;
    const videoLink = draft.introVideoLink();
    const form = useForm({
        mode: 'all',
        defaultValues: {
            videoLink: videoLink || ''
        }
    });
    const [videoPlayableStatus, setVideoPlayableStatus] = useState();
    return /*#__PURE__*/ _jsx(IntroVideoModalContent, {
        form: form,
        setInputVideoName: (inputVideoName)=>setDraft(draft.setIntroVideo(inputVideoName ? {
                type: IntroVideoType.VideoLink,
                videoLink: {
                    url: form.getValues('videoLink')
                }
            } : {
                type: IntroVideoType.None
            })),
        setVideoPlayableStatus: setVideoPlayableStatus,
        videoPlayableStatus: videoPlayableStatus
    });
};
export default function IntroductoryVideoCell(param) {
    let { draft, index, onOpenModal, isDisabled, disabledTooltip } = param;
    const videoUrl = draft.introVideoLink();
    const onClick = ()=>onOpenModal({
            submitOnNotDirty: true,
            shouldSubmit: async (draft)=>draft.introVideoLink() !== videoUrl,
            renderContent: (param)=>{
                let { draft, setDraft } = param;
                return {
                    title: 'Introductory video',
                    testId: 'edit-introductory-video-modal',
                    content: /*#__PURE__*/ _jsx(IntroductoryVideoModalContent, {
                        draft: draft,
                        setDraft: setDraft
                    }),
                    onSubmit: (defaultBehavior)=>{
                        defaultBehavior();
                    }
                };
            }
        });
    return /*#__PURE__*/ _jsx(EditableTableCell, {
        testId: "edit-introductory-video-".concat(index),
        onClick: onClick,
        isDisabled: isDisabled,
        disabledTooltip: disabledTooltip,
        children: /*#__PURE__*/ _jsx(Typography, {
            ellipsis: true,
            testId: "introductory-video-".concat(index),
            skin: videoUrl ? 'standard' : 'secondary',
            children: videoUrl || 'Not set'
        })
    });
}
